

<template>
    <div>
        <!-- <h2>form4</h2> -->
        <a-form-model ref="ruleForm" style="padding-right: 0px" :model="form" :label-col="labelCol" :rules="rules">
            <!-- <div class="item-line">经销商信息</div> -->
            <!-- <a-row> -->
                <!-- <a-col :span="12">
                    <a-form-model-item label="区域" prop="mbrAreaList">
                        <a-cascader
                            v-model="form.mbrAreaList"
                            :options="regionOptions"
                            :fieldNames="{ label: 'areaName', value: 'areaId', children: 'children' }"
                            placeholder="请选择区域"
                            allowClear
                        />
                    </a-form-model-item>
                </a-col> -->
                <!-- <a-col :span="12">
                    <a-form-model-item label="经销商" prop="dealerName">
                        <a-input v-model="form.dealerName" />
                    </a-form-model-item>
                </a-col> -->
            <!-- </a-row> -->
            <!-- <div class="item-line">活动信息</div> -->
            <!-- <a-row> -->
                <!-- <a-col :span="12">
                    <a-form-model-item label="活动类型" prop="threeLevelName">
                        <a-select v-model="form.threeLevelName">
                            <a-select-option value="直播（短视频）">直播（短视频）</a-select-option>
                            <a-select-option value="平台运营">平台运营</a-select-option>
                            <a-select-option value="网红传播">网红传播</a-select-option>
                            <a-select-option value="产品展示">产品展示</a-select-option>
                            <a-select-option value="客户拜访（座谈）">客户拜访（座谈）</a-select-option>
                            <a-select-option value="试驾推介会">试驾推介会</a-select-option>
                            <a-select-option value="客户联谊">客户联谊</a-select-option>
                            <a-select-option value="广告">广告</a-select-option>
                            <a-select-option value="发布品鉴会（答谢会）">发布品鉴会（答谢会）</a-select-option>
                            <a-select-option value="双节拜访">双节拜访</a-select-option>
                            <a-select-option value="婚车">婚车</a-select-option>
                            <a-select-option value="赞助">赞助</a-select-option>
                            <a-select-option value="交车仪式">交车仪式</a-select-option>
                            <a-select-option value="事件慰问">事件慰问</a-select-option>
                            <a-select-option value="望子乘龙">望子乘龙</a-select-option>
                            <a-select-option value="乘龙助学">乘龙助学</a-select-option>
                            <a-select-option value="卡友体检">卡友体检</a-select-option>
                            <a-select-option value="公益项目">公益项目</a-select-option>
                            <a-select-option value="客户来柳参观">客户来柳参观</a-select-option>
                            <a-select-option value="行业客户专项拜访">行业客户专项拜访</a-select-option>
                            <a-select-option value="意向合作伙伴来柳">意向合作伙伴来柳</a-select-option>
                            <a-select-option value="意向网络座谈">意向网络座谈</a-select-option>
                            <a-select-option value="渠道培训">渠道培训</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col> -->
            <!-- </a-row> -->
            <a-row class="flex-row">
              <a-col :span="12">
                <a-form-model-item label="品系"  prop="strainsNameList">
                  <div style="display: flex; flex-direction: column; gap: 4px;width: 100%">
                    <a-select v-model="form.strainsNameList" mode="multiple" placeholder="请选择品系" :collapse-tags="true" @change="onStrainsChange" :disabled="isDisabled()">
                      <!-- <a-select-option  value="0" >全部</a-select-option> -->
                      <a-select-option v-for="item in carStrainsDS" :key="item.strainsCode"  :value="item.strains" >{{item.strains}}</a-select-option>
                    </a-select>
                    <div style="color: #999; font-size: 12px; line-height: 1.4;">
                      注意：公路用车与工程用车不可同时选择
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
                <a-col :span="12">
                    <a-form-model-item label="平台名" prop="platform">
                        <a-select v-model="form.platform" :disabled="isDisabled()">
                            <a-select-option value="卡车之家">卡车之家</a-select-option>
                            <a-select-option value="运满满">运满满</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <!-- <a-col :span="12">
                    <a-form-model-item label="时间" prop="activityTime">
                        <a-date-picker valueFormat="YYYY-MM-DD" v-model="form.activityTime" class="date-picker"/>
                    </a-form-model-item>
                </a-col> -->
            <!-- </a-row> -->
            <!-- <div class="item-line">负责人信息</div> -->
            <!-- <a-row class="flex-row"> -->
                <a-col :span="12">
                    <a-form-model-item label="负责人姓名"  prop="headName">
                        <a-input v-model="form.headName" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="负责人电话" prop="headPhone">
                        <a-input v-model="form.headPhone" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
              
                    <a-col :span="24">
                        <a-form-model-item label="备注" :label-col="{span:4}" class="sign-tiem widthHuo">
                            <a-textarea :auto-size="{ minRows: 2, maxRows: 6 }" v-model="form.remark" :disabled="isDisabled()" />
                        </a-form-model-item>
                    </a-col>
              
             <div class="item-line">费用预算</div>     
             <!-- lr0047           -->
                <a-col :span="6">
                    <a-form-model-item label="年费" prop="annualFee">
                        <a-input-number :min="0" @change="gettotalCost" v-model="form.annualFee" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
            <a-col :span="6">
                <a-form-model-item label="合计" >
                    <!-- <a-input-number :min="0" v-model="form.totalCost" /> -->
                    <a-input-number :min="0" v-model="form.totalCost" disabled/>
                </a-form-model-item>
            </a-col>
        </a-row>   

            <a-row v-if="approveBtnDisplay === true">
            <!-- <a-row> -->
                <a-col :span="6">
                    <a-form-model-item label="经销商已补差">
                        <a-input v-model="form.dealerDiff" disabled />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="区域已补差">
                        <a-input v-model="form.areaDiff" disabled />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="最高支持费用">
                        <a-input v-model="form.maxSupportFee" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
            </a-row>
           
        </a-form-model>
    </div>
</template>

<script>
import { loadAreaTreeCasData } from '@/services/baseCodeSource';
import {getApproveWriteOffCost, queryCarStrainsInfo} from '@/api/activity.js'   // getCarTypeList

const activityFormMap = {
        // "form1": ["直播（短视频）", "网红传播", "试驾推介会", "婚车", "赞助", "交车仪式", "客户联谊", "意向合作伙伴来柳", "意向网络座谈", "渠道培训"],
        // "form2": ["产品展示"],
        // "form3": ["客户拜访（座谈）", "双节拜访", "客户来柳参观", "行业客户专项拜访"],
        // "form4": ["平台运营"],
        // "form5": ["事件慰问", "望子乘龙", "乘龙助学", "卡友体检", "公益项目"],
        // "form7": ["广告", "发布品鉴会（答谢会）"]

        "form1": ["直播（短视频）", "网红传播", "试驾推介会", "婚车服务", "生态赞助", "交车仪式", "客户联谊", "意向合作伙伴来柳", "意向网络座谈", "渠道培训", "集中交车"],
        "form2": ["产品展示","区域车展"],
        "form3": ["客户拜访（座谈）", "双节拜访", "客户来柳参观", "行业客户专项拜访","协会入会",],
        "form4": ["平台运营"],
        "form5": ["事件慰问", "望子乘龙", "乘龙助学", "卡友体检", "公益项目"],
        "form7": ["广告投放", "品鉴会/答谢会"]
    }
export default {
    props:['formData', 'activity', 'formType', 'approveBtnType', 'priceDiff'],
    data() {
    return {
      labelCol: { span: 8, style: { width: '100px' } },
      wrapperCol: { span: 14 },
      form: {
        address: [], // 区域
        dealerName: '', // 经销商
        threeLevelName: '', // 活动类型
        platform: '', // 平台名
        // activityTime: '', // 时间
        headName: '',
        headPhone: '',
        conferenceFee: '', //会务费
        fuelCost: '', // 油费
        toll: '', // 过路费
        giftFee: '', // 礼品费
        moveInFee: '', // 布展费
        otherFee: '',
        totalCost: '', //总计
        dealerDiff: '',
        areaDiff: '',
        maxSupportFee: '',
        remark: '',
        annualFee: '', //年费
        strainsNameList: [],
        strainsCodeNameMap: {}, // 主推品系编码及对应名称
        // trainingFee: 0, //培训费
        // siteRent: 0, //场地租金
        // makeCosts: 0, //制作费用
        // otherSiteExpenses: 0, //其他场地费用
      },
      regionOptions:[],
      rules: {
        mbrAreaList: [
          { required: true, message: '请选择区域', trigger: 'change' },
        ],
        dealerName: [
          { required: true, message: '请输入经销商名称', trigger: 'blur' },
        ],
        threeLevelName: [
          { required: true, message: '请选择活动类型', trigger: 'change' },
        ],
        platform: [
          { required: true, message: '请选择平台名称', trigger: 'change' },
        ],
        activityTime: [
          { required: true, message: '请选择时间', trigger: 'change' },
        ],
        headName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        headPhone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^[1][3-9][0-9]{9}$/, message: '请输入有效的手机号码', trigger: 'blur' },
        ],
        strainsNameList: [
          { required: true, message: '请选择品系', trigger: 'blur' },
        ],
      },
      carStrainsDS: [],
      vehicleModelAndQuantity: [], //已选车型
      vehicleModelCheck: 0, // 0不检验 1校验 车型代码必选
      approveBtnDisplay: false
    };
  },
  created() {
    this.getArea()
    this.SelectListsFun()
    this.getCarStrains()
  },
  mounted() {
    if (this.formData && this.formData.id) {
        setTimeout(() => {
          this.getApproveWriteOffCost()
          this.form  = Object.assign(this.form, {
              ...this.formData,
            //   activityPlace: this.formData.activityPlace.split(',')
                            // activityPlace: this.formData.activityPlace.join(',')

          })
          if(this.carStrainsDS != null) {
            this.form.strainsCodeNameMap = this.carStrainsDS
                .filter(item => this.formData.strainsCodeList.includes(item.strainsCode))
                .reduce((obj, item) => {
                  obj[item.strainsCode] = item.strains;
                  return obj;
                }, {});
          }
          console.log(this.form,'--------this.form--------');
          
          // this.form.dealerDiff = this.priceDiff.dealerDiff
          // this.form.areaDiff = this.priceDiff.areaDiff
        }, 3000)
    }
  },

  methods: {
    // 获取品系
    getCarStrains() {
      queryCarStrainsInfo().then(res => {
        if (res.code === 1) {
          this.carStrainsDS = res.data.list
          this.filteredStrains()
        }
      })
    },
    onStrainsChange (e) {
      this.form.strainsCodeNameMap = this.carStrainsDS
          .filter(item => e.includes(item.strains))
          .reduce((obj, item) => {
            obj[item.strainsCode] = item.strains;
            return obj;
          }, {});
    },
    gettotalCost() {
        this.form.totalCost = Number(this.form.annualFee) 
    },
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['subSeries']).then(v => {
        this.SelectLists = v
      })
    },
    async getArea() {
      this.regionOptions = await loadAreaTreeCasData();
    },
    // 使用这个映射来通过活动类型获取使用的表单
    getFormByActivity(threeLevelName) {
    // 遍历映射对象
    for (const form in activityFormMap) {
        // 检查活动类型是否在当前表单类型的数组中
        if (activityFormMap[form].includes(threeLevelName)) {
        return form;
        }
    }
    // 如果没有找到对应的表单，返回"未知表单"
    return "未知表单";
    },
    onShowCarSeries() {
        console.log("🚀 ~ onShowCarSeries ~ !this.form.strainType:", !this.form.strainType)
        if (!this.form.strainType) {
            this.$message.error('请先选择主推品系')
            return
        }
      this.$refs.selectCarSeriesPopup.blur()
      this.showCarSeries = true
      this.$nextTick(() => {
        if (!this.form.strainsCarName) {
            this.$refs.xTable.clearCheckboxRow()
        }
        // this.$refs.xTable.clearCheckboxRow()
        // const stringArray = this.activity.strainsCarCode.split(',')
        // const result = this.SelectLists.subSeries.filter(item => stringArray.some(value => item.code === value))
        // this.$refs.xTable.setCheckboxRow(result, true)
      })
    },
    getApproveWriteOffCost() {
        getApproveWriteOffCost(this.formData.id).then(res => {
            if (res.code === 1) {
                this.form.dealerDiff = res.data.dealerApproveWriteOffCost
                this.form.areaDiff = res.data.regionApproveWriteOffCost
                this.approveBtnDisplay = res.data.display
            }
        })
    },
    onSeriesConfirm() {
        this.checkedCars = this.$refs.xTable.getCheckboxRecords();
        if (!this.checkedCars.length) {
           return  this.$message.error('请选择车型')
        }
        if (this.checkedCars.some(item => item.count === '')) {
            return  this.$message.error('请输入已选车型的数量')
        }
        this.showCarSeries = false
        const list = this.checkedCars.map(item => `车型名称：${item.carName} - 数量：${item.count}`)
        this.form.strainsCarName = list.join('; ')
    },
    getActivityForm() {
      const processedForm = {
        ...this.form,
        annualFee: this.form.annualFee ?? 0,
        totalCost: this.form.totalCost ?? 0
      };

      const obj = Object.assign(processedForm, {
            address: this.activity.address,
            dealerName: this.activity.dealerName,
            threeLevelName: this.activity.threeLevelName,
        })
        return obj
    },
    isDisabled() {
        console.log("🚀 ~ isDisabled ~ this.formType:", this.formType)
        return this.formType === 'detail'
    }
  }
}
</script>

<style lang="less" scoped>
.item-line {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
  .car-modal {
    /deep/ .ant-form {
        padding-right: 0;
      }
    /deep/ .ant-form-item-control-wrapper {
        width: 100%;
    }
  }
  .widthHuo{
    ::v-deep .ant-form-item-label{
      width:100px !important
    }
  }
</style>